export const sepaCountriesList = [
  {
    countryCode: "AT",
    ibanLength: 20,
    country: "Austria",
  },
  {
    countryCode: "AD",
    ibanLength: 24,
    country: "Andorra",
  },
  {
    countryCode: "BE",
    ibanLength: 16,
    country: "Belgium",
  },
  {
    countryCode: "BG",
    ibanLength: 22,
    country: "Bulgaria",
  },
  {
    countryCode: "HR",
    ibanLength: 21,
    country: "Croatia",
  },
  {
    countryCode: "CY",
    ibanLength: 28,
    country: "Cyprus",
  },
  {
    countryCode: "CZ",
    ibanLength: 24,
    country: "Czech Republic",
  },
  {
    countryCode: "DK",
    ibanLength: 18,
    country: "Denmark",
  },
  {
    countryCode: "EE",
    ibanLength: 20,
    country: "Estonia",
  },
  {
    countryCode: "FI",
    ibanLength: 18,
    country: "Finland",
  },
  {
    countryCode: "FR",
    ibanLength: 27,
    country: "France",
  },
  {
    countryCode: "DE",
    ibanLength: 22,
    country: "Germany",
  },
  {
    countryCode: "GI",
    ibanLength: 23,
    country: "Gibraltar",
  },
  {
    countryCode: "GR",
    ibanLength: 27,
    country: "Greece",
  },
  {
    countryCode: "HU",
    ibanLength: 28,
    country: "Hungary",
  },
  {
    countryCode: "IS",
    ibanLength: 26,
    country: "Iceland",
  },
  {
    countryCode: "IE",
    ibanLength: 22,
    country: "Ireland",
  },
  {
    countryCode: "IT",
    ibanLength: 27,
    country: "Italy",
  },
  {
    countryCode: "LV",
    ibanLength: 21,
    country: "Latvia",
  },
  {
    countryCode: "LI",
    ibanLength: 21,
    country: "Liechtenstein",
  },
  {
    countryCode: "LT",
    ibanLength: 20,
    country: "Lithuania",
  },
  {
    countryCode: "LU",
    ibanLength: 20,
    country: "Luxembourg",
  },
  {
    countryCode: "MT",
    ibanLength: 31,
    country: "Malta",
  },
  {
    countryCode: "MC",
    ibanLength: 27,
    country: "Monaco",
  },
  {
    countryCode: "NL",
    ibanLength: 18,
    country: "Netherlands",
  },
  {
    countryCode: "NO",
    ibanLength: 15,
    country: "Norway",
  },
  {
    countryCode: "PL",
    ibanLength: 28,
    country: "Poland",
  },
  {
    countryCode: "PT",
    ibanLength: 25,
    country: "Portugal",
  },
  {
    countryCode: "RO",
    ibanLength: 24,
    country: "Romania",
  },
  {
    countryCode: "SM",
    ibanLength: 27,
    country: "San Marino",
  },
  {
    countryCode: "SK",
    ibanLength: 24,
    country: "Slovakia",
  },
  {
    countryCode: "SI",
    ibanLength: 19,
    country: "Slovenia",
  },
  {
    countryCode: "ES",
    ibanLength: 24,
    country: "Spain",
  },
  {
    countryCode: "SE",
    ibanLength: 24,
    country: "Sweden",
  },
  {
    countryCode: "CH",
    ibanLength: 21,
    country: "Switzerland",
  },
  {
    countryCode: "GB",
    ibanLength: 22,
    country: "United Kingdom",
  },
];
